export default {
  title: {
    en: 'Share review',
  },
}
